/* eslint-disable */
import closeNoBackground from "@assets/svg/close-no-background.svg";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NotificationDetails } from "@redux/types/NotificationDetails";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IState } from "@customTypes/ItemTypes";
import { NotificationBar } from "./NotificationBar/NotificationBar";

export function BellNotification(): JSX.Element {
  const notificationDetails = useSelector(
    (state: any) => state.notificationDetails
  );
  const { notifications } = notificationDetails;
  const isMobile = useSelector((state: IState) => state.isMobile);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const NotificationList = ({ listItem }: any) => (
    <div className={isMobile ? "nav-link padding-box" : "nav-link nav-link-desktop"}>
      <div className="menu-options">
        <NotificationBar key={listItem.id} element={listItem} />
      </div>
    </div>
  );

  /* Applyig useEffect to disable mobile view effects once screen view is switched to other devices  */
  useEffect(() => {
    !isMobile && setShowMobileMenu(false);
  }, [isMobile]);

  const showNotificationDrawer = () => {
    isMobile && notifications.length && setShowMobileMenu(true);
  };

  return (
    <>
      <div aria-label="notificationInfo">
        <FontAwesomeIcon
          icon={faBell}
          className="icon-user"
          onClick={showNotificationDrawer}
        />
        {notifications.length > 0 && (
          <div className={
            `w-64 bg-white p-4 absolute mt-6 right-1.5 text-left ${showMobileMenu ? "menu-content showMobileMenu" : "menu-content"}`
          }>
          {isMobile ? (
            <div className="menu-arrow-info">
              <div
                className="mobile-close icon-cancel"
                onClick={() => setShowMobileMenu(false)}
              >
                <img src={closeNoBackground} alt="Close" />
              </div>
              {notifications.map((ele: NotificationDetails) => {
                return <NotificationList key={ele.id} listItem={ele} />;
              })}
            </div>
          ) : (
            <div className="menu-arrow-info">
              {notifications.map((notification: NotificationDetails) => {
                return (
                  <NotificationList
                    key={notification.id}
                    listItem={notification}
                  />
                );
              })}
            </div>
          )}
        </div>
        )}        
        </div>

      {notifications.length > 0 && (
        <div
          className="badge"
          id="notification-badge"
          onClick={showNotificationDrawer}
        >
          {notifications.length}
        </div>
      )}
    </>
  );
}
